import { motion } from "framer-motion";

import welcomeImage from './assets/welcome-woman.png';

const HeroSection = () => {
  return (
    <section className="w-full bg-[#e8d9ff] py-20 px-4 sm:px-6">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* Left Column – 60% with animation */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h5 className="uppercase text-sm font-medium text-black mb-2">
            Hospitality
          </h5>

          <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
            Welcome to Next-Level
            <br />
            hospitality
          </h2>

          <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
            Step into a world where comfort meets sophistication and every
            detail is crafted with you in mind. Our approach to hospitality goes
            beyond expectations.
          </p>
        </motion.div>

        {/* Right Column – 40% with animation */}
        <motion.div
          className="w-full lg:w-[40%] flex justify-center"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <img src={welcomeImage} alt="Welcome" className="w-[400px] h-auto" />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
